export default function(s) {
    return new Handlebars.SafeString(s ? encodeURIComponent(s) : "");
}